import { AttributionControl } from 'react-map-gl'
import React, {useEffect } from 'react'
import PropTypes from 'prop-types'

export default function SmartAttributionControl({ base, baseLayers }) {
  const activeBase = Array.isArray(baseLayers)
    ? baseLayers.find(b => b.id === base)
    : null

  const attributionMap = {
    satellite: 'Powered by Esri',
    street:    'Powered by Esri',
  }

  const customAttribution = activeBase?.id
    ? attributionMap[activeBase.id]
    : null
  const key = customAttribution ? `custom-${activeBase.id}` : 'default'

  useEffect(() => {
    // Needs to load the attributions after the map controls or it will be mid screen
    const container = document.querySelector('.maplibregl-ctrl-bottom-right')
    const attribution = document.querySelector('.maplibregl-ctrl-attrib')

    if(container && attribution) {
      container.appendChild(attribution)
    }
  }, [base])

  return (
    <AttributionControl
      key={key}
      position="bottom-right"
      compact={false}
      {...(customAttribution && { customAttribution })}
    />
  )
}
SmartAttributionControl.propTypes = {
    base:       PropTypes.string.isRequired,
    baseLayers: PropTypes.array.isRequired,
}